import { path } from "../utils";
import { PVT as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = { ...defaultOptions };

  function calculator(data = []) {
    const { sourcePath, volumePath } = options;

    const getPrice = path(sourcePath);
    const getVolume = path(volumePath);

    const results = new Array(data.length).fill(undefined);
    let total = 0;

    for (let index = 0; index < data.length; index += 1) {
      const datum = data[index];
      const previousDatum = index > 0 ? data[index - 1] : undefined;

      // First bar: initialize to 0
      if (!previousDatum) {
        results[index] = total;
        continue;
      }

      // Convert values to numbers
      const currentPrice = Number(getPrice(datum));
      const previousPrice = Number(getPrice(previousDatum));
      const volumeCandidate = Number(getVolume(datum));

      // Skip if we don't have valid data
      if (!Number.isFinite(currentPrice) || !Number.isFinite(previousPrice)) {
        results[index] = total;
        continue;
      }

      // Skip if previous price is zero (avoid division by zero)
      if (previousPrice === 0) {
        results[index] = total;
        continue;
      }

      const volumeValue = Number.isFinite(volumeCandidate)
        ? volumeCandidate
        : 0;

      // PVT Formula: total += Volume * (Price - PrevPrice) / PrevPrice
      const priceChange = (currentPrice - previousPrice) / previousPrice;
      total += volumeValue * priceChange;

      results[index] = total;
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return { ...options };
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
